import { render } from "./ChampionsView.vue?vue&type=template&id=50951e82"
import script from "./ChampionsView.vue?vue&type=script&lang=js"
export * from "./ChampionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__